/**
 * Form Elemets
 */

import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { job_location, talukas } from "../../constants.js";
import watsapp from "../../assets/img/profiles/watsapp.png";
import cover from "../../assets/img/flags/SBA-jobfair.png";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner.jsx";
//import cover1 from "../../assets/img/profiles/Untitled.jpg";
import jobPDF from "../../assets/Jobs.pdf";
import moment from "moment";
//import validator from "validator";
import errLogo from "../../assets/img/error 1.png";
import {
  sector,
  gender,
  //taluka,
  specialization,
  grad_data,
  category,
  dist,
  salary_range,
  experience,
} from "../../constants.js";
import axios from "axios";
//import { checkPropTypes } from "prop-types";
import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";

import { DatePicker } from "@progress/kendo-react-dateinputs";
import "@progress/kendo-theme-material/dist/all.css";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import {  DemoItem } from '@mui/x-date-pickers/internals/demo';

const HorizontalForm = () => {
  const [formDetails, setFormDetails] = useState({
    first_name: "",
    last_name: "",
    father_name: "",
    email: "",
    birth_date: "",
    gender: "",
    district: "",
    taluka: "",
    qualification: "",
    stream: "",
    mobile: "",
    cast: "",
    job_Location: "",
    sub_cast: "",
    aadhar: "",
    job_fair_location: "",
    industry: "",
    preffered_work: "",
    notification: 0,
    salary: "",
    experience: "",
  });
  //const [joblocation, setjobLocation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [check, setCheck] = useState(false);
  const [desi, setDesi] = useState([]);
  const ref = useRef(null);
  //console.log(formDetails);
  const [startdate, setStartDate] = useState("");

  const base_url = "https://samarth.prod.api.sapioglobal.com";
  // "https://samarth.uat.api.globalsapio.com";
  // "https://7e55uus5l5.execute-api.ap-south-1.amazonaws.com/dev";

  const fetchData1 = async () => {
    try {
      // const response = await axios.get(
      //   `https://7e55uus5l5.execute-api.ap-south-1.amazonaws.com/dev/desg`
      // );
      const response = await axios.get(`${base_url}/form/desg`);
      const data = response.data;
      console.log(data);
      setDesi(
        // data
        Object.values(data.name).map((ele) => ({
          label: ele,
          value: ele,
        }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  {
    /*
  const fetchData2 = async () => {
    try {
      const response = await axios.get("base_url/industrylist")
      const data = response.data
      console.log(data)
    }
    catch (err) {
      console.log(err)
    }
  }
  */
  }

  useEffect(() => {
    fetchData1();
    //fetchData2()
  }, []);

  const getAge = (bdate) => {
    console.log(bdate);
    const age = Number(
      Math.floor(
        (new Date().getTime() - new Date(bdate).getTime()) /
          (1000 * 60 * 60 * 24)
      ) / 365
    ).toFixed(0);
    return age;
  };

  const SetAge = (e) => {
    if (18 <= getAge(e.target.value) && getAge(e.target.value) <= 60) {
      setFormDetails({
        ...formDetails,
        birth_date: e.target.value,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Age should be between 18 to 60.",
        showConfirmButton: false,
        timer: 2000,
      });
      ref.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (!formDetails.mobile.match("[0-9]{10}")) {
      Swal.fire({
        icon: "error",
        title: "",
        text: "Please provide valid mobile number.",
        showConfirmButton: false,
        timer: 2000,
      });
    } else if (
      60 <= getAge(formDetails.birth_date) &&
      getAge(formDetails.birth_date) <= 18
    ) {
      // SetAge();
      Swal.fire({
        icon: "error",
        title: "",
        text: "Age should be between 18 to 60.",
        showConfirmButton: false,
        timer: 2000,
      });
    } else {
      setIsLoading(true);
      await axios
        .post(`${base_url}/form/jobfair`, {
          first_name: formDetails.first_name,
          last_name: formDetails.last_name,
          father_name: formDetails.father_name,
          email: formDetails.email,
          birth_date: moment(formDetails.birth_date).format("YYYY-MM-DD"),
          // formDetails.birth_date,
          // formDetails.birth_date.getDate() + '-' + ( formDetails.birth_date.getMonth() )+ '-' + formDetails.birth_date.getFullYear(),
          gender: formDetails.gender,
          district: formDetails.district,
          taluka: formDetails.taluka,
          qualification: formDetails.qualification,
          stream: formDetails.stream,
          mobile: formDetails.mobile,
          cast: formDetails.cast,
          sub_cast: formDetails.sub_cast,

          aadhar: formDetails.aadhar,
          job_fair_location: formDetails.job_Location,
          industry: formDetails.industry,
          preffered_work: formDetails.preffered_work,
          notification: check ? 1 : 0,
          salaryrange: formDetails.salary,
          experience: formDetails.experience,
        })
        .then((res) => {
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            title: "",
            text: "Details Submited Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
          setFormDetails({
            first_name: "",
            last_name: "",
            father_name: "",
            email: "",
            birth_date: "",
            gender: "",
            district: "",
            taluka: "",
            qualification: "",
            stream: "",
            mobile: "",
            cast: "",
            job_Location: "",
            sub_cast: "",
            aadhar: "",
            job_fair_location: "",
            industry: "",
            preffered_work: "",
            notification: 1,
            salary: "",
            experience: "",
          });
          setCheck(false);
          //setjobLocation([]);
        })
        .catch((err) => {
          console.log(err.response.data["Developer Message"]);
          console.log("err", err);
          setIsLoading(false);

          err.response.status === 504 || err.response.status === 500
            ? Swal.fire({
                title: "Oops! Try Again",
                text: err.response.statusText,
                imageUrl: errLogo,
                imageWidth: 100,
                imageHeight: 100,
                imageAlt: "Custom image",
                showConfirmButton: true,
              })
            : Swal.fire({
                icon: "error",
                title: "",
                text: err.response.data["Developer Message"],
                showConfirmButton: false,
                timer: 2000,
              });
        });
    }
  };

  // useEffect( ()=>{()
  //   if($('.select').length > 0) {
  //     $('.select').select2({
  //       minimumResultsForSearch: -1,
  //       width: '100%'
  //     });
  //   }
  // });
  return (
    <>
      <div style={{ marginTop: "10px" }}>
        <div>
          <img
            // style={{ width: "100%", height: "auto" }}
            src={cover}
            className="logo-img"
            alt=""
          />
          <img
            // style={{ width: "100%", height: "auto" }}
            src={cover}
            className="logo-img1"
            alt=""
          />
          {isLoading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "100px",
              }}
            >
              <LoadingSpinner />
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title mb-0">Job Fair Registration</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            First Name <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="text"
                              className="form-control input-align"
                              value={formDetails.first_name}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  first_name: e.target.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Last Name <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="text"
                              className="form-control input-align"
                              value={formDetails.last_name}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  last_name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Father's Name <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="text"
                              className="form-control input-align"
                              value={formDetails.father_name}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  father_name: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Email
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="email"
                              className="form-control input-align"
                              value={formDetails.email}
                              onChange={(e) => {
                                setFormDetails({
                                  ...formDetails,
                                  email: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Gender <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="password" className="form-control" /> */}
                            <Select
                              options={gender}
                              placeholder=" Select Gender"
                              value={
                                formDetails.gender !== ""
                                  ? {
                                      label: formDetails.gender,
                                      value: formDetails.gender,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  gender: e.value,
                                })
                              }
                            />
                          </div>
                          {/* <div className="col-lg-9">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender_male"
                            defaultValue="option1"
                            defaultChecked
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gender_male"
                          >
                            Male
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender_female"
                            defaultValue="option2"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gender_female"
                          >
                            Female
                          </label>
                        </div>
                      </div> */}
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Date of Birth <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input
                              type="date"
                              className="form-control input-align"                      
                              ref={ref} */}
                            {/* // pattern="\d{4}-\d{2}-\d{2}"
                              max={moment().format("YYYY-MM-DD")}
                              value={formDetails.birth_date}
                              //  onChange={SetAge}
                              //  min="1980-01-01"
                              //  max="2005-12-31" */}
                            {/* onChange={(e)=>{
                                setFormDetails({
                                  ...formDetails,
                                  birth_date: e.target.value,
                                })
                                
                              }}
                            />  */}

                            <DatePicker
                              // className="form-control input-align"
                              // width="100%"
                              // defaultValue=""
                              // defaultShow={true}
                              backgroundColor="#fff"
                              size="medium"
                              placeholder="dd-mm-yyyy"
                              format="dd-MM-yyyy"
                              // selected={formDetails.birth_date}
                              onChange={(e) => {
                                setFormDetails({
                                  ...formDetails,
                                  birth_date: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            District <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <select className="select">
                            <option>Select</option>
                            <option value={1}>A+</option>
                            <option value={2}>O+</option>
                            <option value={3}>B+</option>
                            <option value={4}>AB+</option>
                          </select> */}
                            <Select
                              options={dist}
                              placeholder="Select District"
                              value={
                                formDetails.district !== ""
                                  ? {
                                      label: formDetails.district,
                                      value: formDetails.district,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  district: e.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Taluka <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            <Select
                              options={
                                formDetails.district === "Mumbai City" ||
                                formDetails.district === "Mumbai Suburban"
                                  ? talukas["Mumbai"]
                                  : talukas[formDetails.district]
                              }
                              placeholder=" Select Taluka"
                              value={
                                formDetails.taluka !== ""
                                  ? {
                                      label: formDetails.taluka,
                                      value: formDetails.taluka,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  taluka: e.value,
                                })
                              }
                            />

                            {/* <Select /> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Qualification <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="text" className="form-control" /> */}
                            <Select
                              options={grad_data}
                              placeholder="Select Qualification"
                              value={
                                formDetails.qualification !== ""
                                  ? {
                                      label: formDetails.qualification,
                                      value: formDetails.qualification,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  qualification: e.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Stream <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="text" className="form-control" /> */}
                            <Select
                              options={specialization}
                              placeholder="Select stream"
                              value={
                                formDetails.stream !== ""
                                  ? {
                                      label: formDetails.stream,
                                      value: formDetails.stream,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  stream: e.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Mobile Number <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            <input
                              pattern="[789][0-9]{9}"
                              type="number"
                              inputMode="numeric"
                              className="form-control input-align"
                              value={formDetails.mobile}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  mobile: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Aadhaar Number
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="number"
                              pattern="[0-9]{12}"
                              className="form-control input-align"
                              value={formDetails.aadhar}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  aadhar: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Caste Category <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="text" className="form-control" /> */}
                            <Select
                              options={category}
                              placeholder="Select Caste Category"
                              value={
                                formDetails.cast !== ""
                                  ? {
                                      label: formDetails.cast,
                                      value: formDetails.cast,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  cast: e.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Sub Caste
                          </label>
                          <div className="col-lg-9">
                            <input
                              type="text"
                              className="form-control input-align"
                              value={formDetails.sub_cast}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  sub_cast: e.target.value,
                                })
                              }
                            />
                            {/* <Select /> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Job Fair Location{" "}
                            <sup style={{ color: "red" }}>*</sup>
                          </label>

                          <div className="col-lg-6">
                            {/* <input type="text" className="form-control" /> */}

                            <Select
                              // isMulti
                              placeholder="Select Job Fair Location"
                              options={job_location}
                              // value={joblocation}
                              // onChange={(e) => {
                              //   if (e) {
                              //     setjobLocation(e.map((item) => item));
                              //   } else {
                              //     setjobLocation([]);
                              //   }
                              // }}
                              value={
                                formDetails.job_Location !== ""
                                  ? {
                                      label: formDetails.job_Location,
                                      value: formDetails.job_Location,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  job_Location: e.value,
                                })
                              }
                              required
                            />
                          </div>
                          <div className="col-lg-3">
                            <button
                              className="btn"
                              disabled={job_location.length === 0}
                            >
                              <i
                                class="fa fa-calendar-o"
                                aria-hidden="true"
                              ></i>{" "}
                              <a
                                href={jobPDF}
                                target="_blank"
                                rel="noreferrer"
                                className="text-dark"
                              >
                                {" "}
                                Job Fair Details
                              </a>{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Industry Sector{" "}
                            <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="text" className="form-control" /> */}
                            <Select
                              options={sector}
                              placeholder="Select Industry"
                              value={
                                formDetails.industry !== ""
                                  ? {
                                      label: formDetails.industry,
                                      value: formDetails.industry,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  industry: e.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Preferred Work <sup style={{ color: "red" }}>*</sup>
                          </label>
                          <div className="col-lg-9">
                            {/* <input type="text" className="form-control" /> */}
                            <Select
                              options={desi}
                              placeholder="Select Preferred Work"
                              value={
                                formDetails.preffered_work !== ""
                                  ? {
                                      label: formDetails.preffered_work,
                                      value: formDetails.preffered_work,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  preffered_work: e.value,
                                })
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Expected salary per month
                          </label>
                          <div className="col-lg-9">
                            <Select
                              options={salary_range}
                              placeholder="Expected salary per month"
                              value={
                                formDetails.salary !== ""
                                  ? {
                                      label: formDetails.salary,
                                      value: formDetails.salary,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  salary: e.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label label-align">
                            Experience
                          </label>
                          <div className="col-lg-9">
                            <Select
                              options={experience}
                              placeholder="Select Experience"
                              value={
                                formDetails.experience !== ""
                                  ? {
                                      label: formDetails.experience,
                                      value: formDetails.experience,
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  experience: e.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            name="checkbox"
                            checked={check}
                            onChange={() => setCheck(!check)}
                          />{" "}
                          &nbsp;{" "}
                          <img
                            src={watsapp}
                            style={{ height: "30px", width: "30px" }}
                            alt=""
                          />{" "}
                          &nbsp;{" "}
                          {`I give the consent to share my details and I allow to send me further details and updates over WhatsApp.`}
                        </label>
                      </div>
                      <br />
                      <button
                        disabled={job_location.length === 0}
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => handleSubmit()}
                        // disabled={
                        //   formDetails.first_name === "" ||
                        //   formDetails.last_name === "" ||
                        //   formDetails.father_name === "" ||
                        //   formDetails.gender === "" ||
                        //   formDetails.email === "" ||
                        //   formDetails.birth_date === "" ||
                        //   formDetails.district === "" ||
                        //   formDetails.taluka === "" ||
                        //   formDetails.qualification === "" ||
                        //   formDetails.stream === "" ||
                        //   formDetails.mobile === "" ||
                        //   formDetails.cast === "" ||
                        //   formDetails.industry === "" ||
                        //   check === false ||
                        //   formDetails.aadhar === ""
                        //     ? true
                        //     : false
                        // }
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default HorizontalForm;
